import React from 'react'
import { FixedSizeList } from 'react-window'

type VirtualizedListProps<T> = {
  height: number
  items: T[]
  renderItem: React.ComponentType<{ index: number; style: React.CSSProperties; data: T[] }>
}

export const VirtualizedList = <T,>({ height, items, renderItem }: VirtualizedListProps<T>) => {
  return (
    <FixedSizeList width="100%" height={height} itemSize={30} itemCount={items.length} itemData={items}>
      {renderItem}
    </FixedSizeList>
  )
}
